// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f40a37b","453":"ef588517","455":"0fe48aaf"}[chunkId] + ".chunk.js";
};